<template>
  <div v-html="this.$store.state.inform">
 
  </div>

  <modal v-if="showmodal" @close="update">

    <template v-slot:header>
        <h3 class="text-danger">{{ this.$store.state.danger }}!</h3>
      </template>
      <template v-slot:body>
        {{ this.$store.state.updatemessage  }}
      </template>

  </modal>
</template>

<script>
import modal from "./Modal2";
 

export default {
  components:{modal},
  data(){
return{

showmodal:false

}


  },
 methods:{
update(){

location.reload()

},
            fetchTer(){
                    console.log('start2');
                    this.$api("/api/data/5/"+this.$store.state.terid)
                   // .then(res => res.json())
                    .then(data => this.$store.state.ter=data)
                    .catch(error => {
                          console.log("There was an error!", error)
                    });

                    console.log('stop2');
            } ,

            fetchClass(){
                    console.log('start class');
                    this.$api("/api/data/8/"+this.$store.state.terid)
                   // .then(res => res.json())
                    .then(data => this.$store.state.class=data)
                    .catch(error => {
                          console.log("There was an error!", error)
                    });

// console.log('class',this.$store.state.class);
                    console.log('stop class');
            },
            
                async fetchInform() {
      // console.log("start summary");
      await this.$api( "/api/data/9/"+this.$store.state.iduser)
       // .then((res) => res.json())
        .then((data) => {console.log(data);   this.$store.state.inform = data.text})
        .catch((error) => {
          console.log("There was an error!", error);
        });
 
    },

    async fetchVersion() {
      // alert('->'+this.$store.state.version+'-'+this.$store.state.version2)
      await this.$api(this.$store.state.server + "/api/data/10/"+this.$store.state.iduser)
       // .then((res) => res.json())
        .then((data) => {this.$store.state.version2 = data.version;   })
        .catch((error) => {
          console.log("There was an error!", error);
        });
       
//  console.log("data.version=", this.$store.state.version2);
    },
    checkVersion(){
     console.log("ver", this.$store.state.version, this.$store.state.version2);
      if (this.$store.state.version<this.$store.state.version2)
      {
      this.showmodal=true;

      }

    }

  },
  async mounted () {



  

    if (this.$store.state.ter.length==0)
    {
        this.fetchTer();
       
    }

    // console.log('class',this.$store.state.class);

        if (this.$store.state.class.length==0)
    {
        this.fetchClass();
       
    }

      await  this.fetchInform();
  await  this.fetchVersion();
  this.checkVersion();
  }


}
</script>
